import React from 'react';
import ReactGA from 'react-ga';

export const GAContext = React.createContext();

export const GAProvider = ({ children }) => {
  const GA = (category, action) => {
    ReactGA.event(
      {
        category: category,
        action: action,
        transport: 'beacon',
      },
      ['tracker1', 'tracker2'],
    );
  };

  return <GAContext.Provider value={{ GA }}>{children}</GAContext.Provider>;
};
